import React from 'react';
import Select from 'react-select';

import { StatsFilters } from '../../../../../domain/statsFilters';

type HalfYearPickerProps = {
    halfYearFilters: NonNullable<StatsFilters['halfYear']>;
    onChange: (newFilters: NonNullable<StatsFilters['halfYear']>) => void;
    startYear: number;
}

export const HalfYearPicker = ({ halfYearFilters, onChange, startYear }: HalfYearPickerProps) => {
    const handleHalfYearChange = (newHalfYear: number) => {
        onChange({
            ...halfYearFilters,
            halfYear: newHalfYear,
        });
    };

    const handleYearChange = (newYear: number) => {
        onChange({
            ...halfYearFilters,
            year: newYear,
        });
    };

    const currentYear = new Date().getFullYear();
    const yearsCount = currentYear - startYear + 1;
    const years = Array.from({ length: yearsCount }, (_, i) => currentYear - i);

    const halfYearOptions = [
        { value: 1, label: 'I półrocze (styczeń-czerwiec)' },
        { value: 2, label: 'II półrocze (lipiec-grudzień)' },
    ];

    const yearOptions = years.map(year => ({
        value: year,
        label: year.toString(),
    }));

    const selectedHalfYear = halfYearOptions.find(option => option.value === halfYearFilters.halfYear);
    const selectedYear = yearOptions.find(option => option.value === halfYearFilters.year);

    return (<div className="d-flex">
        <Select
            value={selectedHalfYear}
            onChange={(value) => handleHalfYearChange(value?.value as number)} // because this Select is not clearable it's never going to be an undefined
            options={halfYearOptions}
            placeholder="Wybierz półrocze"
            className="me-3"
        />
        <Select
            value={selectedYear}
            onChange={(value) => handleYearChange(value?.value as number)} // because this Select is not clearable it's never going to be an undefined
            options={yearOptions}
            placeholder="Wybierz rok"
        />
    </div>);

};